import { render, staticRenderFns } from "./gift-manage-index.vue?vue&type=template&id=162f5559"
import script from "./gift-manage-index.vue?vue&type=script&lang=js"
export * from "./gift-manage-index.vue?vue&type=script&lang=js"
import style0 from "./gift-manage-index.vue?vue&type=style&index=0&id=162f5559&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports